import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-connect-vrbo-phase1',
  templateUrl: './connect-vrbo-phase1.component.html',
  styleUrls: ['./connect-vrbo-phase1.component.scss'],
})
export class ConnectVrboPhase1Component implements OnInit {
  @Input() username: string = '';
  password: string;

  @Input() loading: boolean;
  @Input() mode: 'new' | 'update';

  @Output() phaseComplete: EventEmitter<{
    username;
    password;
  }> = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }
}
